import { User } from '../../types'
import { Avatar, Card, CardContent, Typography } from '@mui/material'
import { translations } from '../../translations';

interface FriendsListProps {
  friends: User[]
  isRtl: boolean
}

export function FriendsList({ friends, isRtl }: FriendsListProps) {
  const t = isRtl ? translations.ku : translations.en;

  return (
    <Card dir={isRtl ? 'rtl' : 'ltr'}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t.friends}
        </Typography>
        {friends.length === 0 && (
          <Typography variant="body1" color="text.secondary">
            {t.noFriends}
          </Typography>
        )}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', direction: isRtl ? 'rtl' : 'ltr' }}>
          {friends.map((friend) => (
            <div
              key={friend.id}
              onClick={() => window.location.href = `/users/${friend.id}`}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '8px',
                direction: isRtl ? 'rtl' : 'ltr',
                cursor: 'pointer'
              }}
            >
              <Avatar src={friend.profile_image_url} alt={friend.name} />
              <div style={{ textAlign: 'center', direction: isRtl ? 'rtl' : 'ltr' }}>
                <Typography variant="body2" fontWeight="medium">
                  {friend.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {friend.books_read || 0} {t.books}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
